<template>
  <div class="custom-proxer">
    <v-dialog
      v-model="dialog"
      width="1200"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          outlined
          v-on="on"
          @click="addCustomProxer"
        >
          Add Custom Proxer
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Custom Proxer
        </v-card-title>

        <v-card-text class="px-0">
          <v-data-table
            :headers="searchResultHeaders"
            :items="searchResultCustomProxer"
            :loading="isLoading"
            item-key="tableKey"
            height="calc(100vh - 300px)"
            fixed-header
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:item.replacer_id="{ item }">
              <span> {{ item.replacer_id }}</span>
            </template>

            <template v-slot:item.entity_id="{ item }">
              <span v-if="!item.edit">{{ getProjectName(item.entity_id) || item.entity_id }}</span>
              <select-project
                v-else
                v-model="item.entity_id"
                :rules="item.edit ? [v => !!v || 'Entity is required'] : []"
                hide-details
                dense
              />
            </template>

            <template v-slot:item.hostname="{ item }">
              <span v-if="!item.edit">{{ item.hostname }}</span>
              <v-text-field
                v-else
                v-model="item.hostname"
                :rules="item.edit ? [v => !!v || 'Hostname is required'] : []"
                hide-details
                dense
              />
            </template>

            <template v-slot:item.brand_id="{ item }">
              <span v-if="!item.edit">{{ getBrandName(item.brand_id) || item.brand_id }}</span>
              <custom-select
                v-else
                :value="item.brand_id"
                @input="(selectedItem) => item.brand_id = selectedItem ? selectedItem.value : null"
                :items="formattedBrandOptions"
                :rules="item.edit ? [v => !!v || 'Brand is required'] : []"
                hide-details
                :outlined="false"
                dense
              />
            </template>

            <template v-slot:item.country="{ item }">
              <span v-if="!item.edit">{{ item.country }}</span>
              <div v-else>
                <select-countries
                  :chosenCountries="item.country"
                  :countries="allCountries"
                  :multiple="false"
                  @input="(items) => item.country = items.value"
                  :outlined="false"
                />
              </div>
            </template>

            <template v-slot:item.ip="{ item }">
              <span v-if="!item.edit">{{ item.ip }}</span>
              <v-text-field
                v-else
                v-model="item.ip"
                hide-details
                dense
              />
            </template>

            <template v-slot:item.action="{ item }">
              <template v-if="!item.edit">
                <div>
                  <v-btn
                  icon
                  small
                  @click="startEdit(item)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                  <v-btn
                    icon
                    small
                    @click="deleteCustomProxer(item)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
                <template v-else>
                 <div class="d-flex">
                   <v-btn
                     icon
                     small
                     @click="cancelEdit(item)"
                   >
                     <v-icon small>mdi-close</v-icon>
                   </v-btn>
                 </div>
                </template>
            </template>
          </v-data-table>

          <div class="d-flex justify-end mt-4 mr-4">
            <v-btn
              color="primary"
              small
              @click="addEmptyRow"
            >
              Add row
            </v-btn>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="isSaveDisabled"
            @click="saveCustomProxers"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import CustomSelect from '@/modules/proxers/CustomSelect.vue'
  import SelectCountries from '@/components/core/SelectCountries.vue'
  import { allCountries } from '@/components/core/SelectLang/mapperIsoLocale'
  import { map, cloneDeep } from 'lodash'
  import { API } from '@/utils/api'

  export default {
    name: 'CustomProxer',
    components: {
      SelectProject,
      CustomSelect,
      SelectCountries
    },
    props: {
      brandList: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        allCountries,
        dialog: false,
        isLoading: false,
        tempRowCounter: 0,
        requiredFields: ['entity_id', 'hostname', 'brand_id'],
        proxerFields: ['entity_id', 'hostname', 'brand_id', 'country', 'ip'],
        searchResultHeaders: [
          { text: 'ID', value: 'replacer_id', sortable: false, width: '8%' },
          { text: 'Entity', value: 'entity_id', sortable: false },
          { text: 'Hostname', value: 'hostname', sortable: false },
          { text: 'Brand', value: 'brand_id', sortable: false },
          { text: 'Country', value: 'country', sortable: false },
          { text: 'IP', value: 'ip', sortable: false },
          { text: 'Actions', value: 'action', sortable: false, width: '8%' }
        ],
        searchResultCustomProxer: []
      }
    },
    computed: {
      formattedBrandOptions () {
        const uniqueBrands = Array.from(
          new Map(
            this.brandList.map(item => [item.brand_id, item])
          ).values()
        )
        return uniqueBrands.map(item => ({
          value: item.brand_id,
          text: item.name,
          system_id: item.system_id
        }))
      },
      isSaveDisabled () {
        if (this.isLoading) {
          return true
        }
        return this.searchResultCustomProxer.some(item => {
          if (!item.edit) {
            return false
          }
          return this.requiredFields.some(field => {
            const value = item[field]
            return value === null || value === undefined || value === ''
          })
        })
      }
    },
    methods: {
      addCustomProxer () {
        this.getCustomProxersList()
      },
      async getCustomProxersList () {
        this.isLoading = true

        try {
          const data = await API.call('/$v/proxer/host_replacer/get.json', {})
          this.searchResultCustomProxer = map(data.proxers.list, proxer => ({
            ...proxer,
            tableKey: proxer.replacer_id || `temp_${++this.tempRowCounter}`,
            edit: false,
            init: cloneDeep(proxer)
          }))
        } catch (e) {
          this.$notification.show = true
          this.$notification.message = 'Failed to load custom proxers'
          this.$notification.type = 'error'
        } finally {
          this.isLoading = false
        }
      },
      addEmptyRow () {
        this.tempRowCounter++
        this.searchResultCustomProxer.push({
          tableKey: `temp_${this.tempRowCounter}`,
          replacer_id: null,
          entity_id: null,
          hostname: '',
          brand_id: null,
          country: '',
          ip: '',
          edit: true,
          init: null,
          newItem: true
        })
      },
      startEdit (item) {
        item.edit = true
      },
      cancelEdit (item) {
        if (item.newItem) {
          this.searchResultCustomProxer = this.searchResultCustomProxer.filter(proxer => proxer.tableKey !== item.tableKey)
          return
        }
        if (item.init) {
          this.proxerFields.forEach(key => {
            this.$set(item, key, item.init[key])
          })
        }
        this.$set(item, 'edit', false)
      },
      async deleteCustomProxer (item) {
        this.isLoading = true
        try {
          await API.call('/$v/proxer/host_replacer/delete.json', { replacer_id: item.replacer_id })
          this.searchResultCustomProxer = this.searchResultCustomProxer.filter(proxer => proxer.tableKey !== item.tableKey)
          this.$notification.show = true
          this.$notification.message = 'Custom proxer deleted'
          this.$notification.type = 'success'
        } catch (e) {
          this.$notification.show = true
          this.$notification.message = 'Failed to delete custom proxer'
          this.$notification.type = 'error'
        } finally {
          this.isLoading = false
        }
      },
      async saveCustomProxers () {
        this.isLoading = true
        try {
          await API.call('/$v/proxer/host_replacer/set.json', { proxers: this.searchResultCustomProxer })
          await this.getCustomProxersList()
          this.$notification.show = true
          this.$notification.message = 'Custom proxers saved'
          this.$notification.type = 'success'
        } catch (e) {
          this.$notification.show = true
          this.$notification.message = 'Failed to save custom proxers'
          this.$notification.type = 'error'
        } finally {
          this.isLoading = false
        }
      },
      closeDialog () {
        this.dialog = false
      },
      getProjectName (entityId) {
        if (!entityId) return null
        const project = this.$store.state.auth.entities.find(e => e.entity_id === entityId)
        return project ? project.name : null
      },
      getBrandName (brandId) {
        if (!brandId) return null
        const brand = this.brandList.find(b => b.brand_id === brandId)
        return brand ? brand.name : null
      }
    }
  }
</script>

<style scoped>
  .custom-proxer {
    display: inline-block;
  }
</style>

